import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ThoughtField } from '../../thought.service';

@Component({
  selector: 'app-long-text',
  templateUrl: './long-text.component.html',
  styleUrls: ['./long-text.component.scss']
})
export class LongTextComponent {

  @Input() field: ThoughtField;
  @Input() isEditing: boolean;
  @Input() index: number;
  @Input() ready: boolean;

  @Output() fieldUpdated = new EventEmitter<ThoughtField>();

  public id: number = Date.now();

  constructor() { }

  public updateRichTextField(data) {
    this.field.value = data;
    this.fieldUpdated.emit(this.field);
  }

}



// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/long-text/long-text.component.ts